/**
 * This barrel file provides the exports for the shared resources (services, components).
 */
export * from './topnav/index';
export * from './sidebar/index';

export * from './name-list/index';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts